import { styled } from '@mui/material/styles';
import { Typography } from '@mui/material';

// ============================================
// Reservation Warning Dialog
// ============================================
export const ReservationWarningTitle = styled(Typography)({
  fontSize: '14px',
  marginBottom: '8px',
});

export const ReservationWarningSub = styled(Typography)({
  fontSize: '13px',
  color: '#666',
});
